import { dateformation2, minusOneDay } from 'src/components/date-format-mdy';

export const defaultConfigureGantt = (gantt, generateColumns, onDrop, onAddLink) => {
  ///user columns
  gantt.config.resource_store = 'resources';
  gantt.config.date_format = '%m-%d-%Y %H:%i';

  gantt.templates.grid_row_class = (start, end, task) => {
    if (task.parent != 0) {
      return 'sub_task';
    } else {
      return 'parent_task';
    }
  };

  const formatBudgetedHrs = (num) => {
    if (num !== undefined) {
      return num.toString().includes('.') && num.toString().split('.')[1].length > 2
        ? num.toFixed(2)
        : num;
    }
    return num; // return undefined if num is undefined
  };
  ///columns for Assigned Resources
  const secondGridColumns = {
    columns: [
      {
        name: 'name',
        label: 'Name',
        width: 60,
        align: 'center',
        tree: true,
        template: function (task) {
          return task.text;
        },
      },
      {
        name: 'budgetedHrs',
        width: 80,
        label: 'Budgeted Hrs',
        align: 'center',
        template: function (task) {
          return formatBudgetedHrs(task.budgetedHrs) + ' ' + 'Hours';
        },
      },
      {
        name: 'assignedHrs',
        width: 80,
        label: 'Assigned Hrs',
        align: 'center',
        template: function (task) {
          return formatBudgetedHrs(task.assignedHrs) + ' ' + 'Hours';
        },
      },
    ],
  };
  //resource assigments
  gantt.templates.resource_cell_value = function (
    start_date,
    end_date,
    resource,
    tasks,
    assignments
  ) {
    // console.log(start_date,end_date,"what happening")
    let backgroundColor = '';
    // console.log(new Date(assignments[0].date)==start_date,"adhsadsagdshadsa")
    // if(start_date==new Date(assignments[0].date)){
    if (assignments[0].budgetedHrs < assignments[0].assignedHrs) {
      backgroundColor = 'orange';
    } else if (assignments[0].budgetedHrs > assignments[0].assignedHrs) {
      backgroundColor = 'red';
    } else if (assignments[0].budgetedHrs == assignments[0].assignedHrs) {
      backgroundColor = 'green';
    }
    var html = `
          <div style="display: flex; gap: 10px; justify-content: center; align-items: center; height: 100%; background-color: ${backgroundColor};">
            <span style="color: black; background-color: white; height: 26px; min-width: 26px; line-height: 26px; text-align: center; display: inline-block; padding: 0px 5px">
              ${assignments[0].budgetedHrs}
            </span>
            <span style="height: 35px; width: 35px; color: white; background-color: black; border-radius: 50%; line-height: 33px; text-align: center; display: inline-block; font-size: 12px;">
              ${assignments[0].assignedHrs}
            </span>
          </div>
        `;
    return html;
    // }
  };
  gantt.templates.grid_row_class = (start, end, task) => {
    if (task.parent != 0) {
      return 'sub_task';
    } else {
      return 'parent_task';
    }
  };

  gantt.config.row_height = 43;

  //resource layout
  gantt.config.layout = {
    css: 'gantt_container',
    rows: [
      {
        css: 'first_grind',
        cols: [
          { view: 'grid', group: 'grids', scrollY: 'scrollVer' },
          { resizer: true, width: 1 },
          { view: 'timeline', scrollX: 'scrollHor', scrollY: 'scrollVer' },
          { view: 'scrollbar', id: 'scrollVer', group: 'vertical' },
        ],
        gravity: 3,
      },
      {
        cols: [
          {
            html: "<div class='resourse-grid-title'>Assign Resources</div>",
            css: 'resourse-grid-title-container',
            width: 435,
            group: 'grids',
          },
          { resizer: true, width: 1 },
          {
            html: "<div class='resourse-grid-title sm-font'>Note: Squares represent required hours per day, and circles represent assigned hours per day.</div>",
            css: 'resourse-grid-title-container',
          },
        ],
        gravity: 0.3,
      },
      {
        cols: [
          {
            html: "<div class=''></div>",
            css: 'resourse-grid-title-container',
          },
        ],
        gravity: 0.4,
      },
      {
        cols: [
          {
            view: 'resourceGrid',
            group: 'grids',
            width: 435,
            scrollY: 'resourceVScroll',
            config: secondGridColumns,
          },
          { resizer: true, width: 1 },
          {
            view: 'resourceTimeline',
            scrollX: 'scrollHor',
            scrollY: 'resourceVScroll',
          },
          { view: 'scrollbar', id: 'resourceVScroll', group: 'vertical' },
        ],
        gravity: 2,
      },
      { view: 'scrollbar', id: 'scrollHor' },
    ],
  };

  //   gantt.config.layout = {
  //     css: "gantt_container",
  //     cols: [
  //         {
  //             width: 400,
  //             rows: [
  //                 {
  //                     id: "mainGrid",
  //                     linkedView: "mainTimeline",
  //                     group: "gantt",
  //                     cols: [
  //                         {
  //                             rows: [
  //                                 { view: "grid", scrollX: "gridScrollX", scrollable: true, scrollY: "scrollVer" },
  //                                 { view: "scrollbar", id: "gridScrollX" }
  //                             ]
  //                         }
  //                     ]
  //                 },
  //                 { resizer: true, width: 1 },
  //                    {
  //             html: "<div class='resourse-grid-title'>Assigned Resources</div>",
  //              css: 'resourse-grid-title-container',
  //             width: 435,
  //             group: 'grids',
  //          },
  //                 { resizer: true, width: 1 },
  //                 {
  //                     id: "resourceGrid",
  //                     linkedView: "resourceTimeline",
  //                     group: "resourceLoad",
  //                     config: secondGridColumns,
  //                     cols: [
  //                         {
  //                             rows: [
  //                                 { view: "resourceGrid", scrollY: "scrollVer2", scrollX: "resourceGridScrollX", scrollable: true },
  //                                 { view: "scrollbar", id: "resourceGridScrollX" }
  //                             ]
  //                         }
  //                     ]
  //                 }
  //             ]
  //         },
  //         { resizer: true, width: 1 },
  //         {
  //             rows: [
  //                 {
  //                     id: "mainTimeline",
  //                     linkedView: "mainGrid",
  //                     group: "gantt",
  //                     cols: [
  //                         {
  //                             rows: [
  //                                 { view: "timeline", scrollX: "scrollHor", scrollY: "scrollVer" },
  //                             ]
  //                         },
  //                         { view: "scrollbar", id: "scrollVer" }
  //                     ]
  //                 },
  //                 { resizer: true, width: 1 },
  //                 {
  //                     id: "resourceTimeline",
  //                     linkedView: "resourceGrid",
  //                     group: "resourceLoad",
  //                     cols: [
  //                         {
  //                             rows: [
  //                                 { view: "resourceTimeline", scrollX: "scrollHor", scrollY: "scrollVer2" },
  //                                 { view: "scrollbar", id: "scrollHor" }
  //                             ]
  //                         },
  //                         { view: "scrollbar", id: "scrollVer2" }
  //                     ]
  //                 }
  //             ]
  //         }
  //     ],
  // }

  gantt.attachEvent('onAfterTaskDrag', (id, mode, e) => {
    const task = gantt.getTask(id);

    // Get updated task details
    const updatedTask = {
      task_id: task?.id,
      start_date: dateformation2(task?.start_date),
      end_date: dateformation2(minusOneDay(task?.end_date)),
      duration: task?.duration,
    };
    onDrop(updatedTask, gantt);
    console.log('Task dropped:', updatedTask, task);
  });

  gantt.attachEvent('onLinkCreated', async (link) => 
    {
    const dataForApi = {
      source: link.source,
      target: link.target,
      type: link.type,
    };
   const response=await onAddLink(dataForApi);
//   console.log(gantt.getLinks(),"??????????")
// const finLink=gantt.getLinks().find((item)=>item.source===link.source && item.target===link.target)
gantt.addLink({
  id: response.id,
  source: link.source,
  target: link.target,
  type: link.type,
});
let allLinks=gantt.getLinks()
const result =allLinks[allLinks.length - 1]
gantt.deleteLink(result.id);
console.log(gantt.getLinks(),"??????????")
  });

 
};
